import { MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

export const ConfigurationWarning = () => (
  <MessageBar severity={TMessageBarSeverity.WARNING}>
    <p className="text-base/[175%] font-semibold text-black">
      Tilbudet er mer enn 45 dager gammelt. Det anbefales å konfigurere tilbudet på nytt i konfiguratoren for å sikre
      korrekte priser og konfigurasjon.
    </p>
  </MessageBar>
);
